"use strict";

function splitDatetime(datetime)
{
	return {
		date: datetime.slice(0, 10),
		time: datetime.slice(11, 16),
		timezoneOffset: datetime.slice(16),
	};
}

export {splitDatetime};
